import { useEffect, useState } from "react";

export const useMedia = (query) => {
  const get = () => typeof window !== "undefined" && window.matchMedia(query).matches;
  const [match, setMatch] = useState(get);
  useEffect(() => {
    const m = window.matchMedia(query);
    const on = () => setMatch(m.matches);
    on();
    m.addEventListener("change", on);
    return () => m.removeEventListener("change", on);
  }, [query]);
  return match;
};

export const usePhone = () => useMedia("(max-width: 767px)");
export const useDesktop = () => useMedia("(min-width: 1024px)");
